// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"5267e8dd8c4ef5a967a6","731":"b4ba08aa6978dfee3a09","843":"3f968b615b900a2e4dc8","883":"f2b9e2d4aaf4f51a754d"}[chunkId] + ".js";
};